import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Spinner from '../components/Common/Spinner/Spinner.jsx';
import Nav from '../components/Common/Nav/Nav.jsx';
import Footer from '../components/Common/Footer/Footer.jsx';
import {setDev as dispatchSetDev} from '../redux/modules/common/common';
import queryString from 'query-string';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import ErrorPanel from '../components/Common/Error/ErrorPanel.jsx';
import classNames from 'classnames';
import {logUserClick} from '../redux/modules/dataLayer/dataLayer';

class AppContainer extends Component {

  getChildContext() {
    return {
      logUserClick: this.props.logUserClick
    };
  }

  componentDidMount() {
    const {
      setDev
    } = this.props;

    const query = queryString.parse(window.location.search);

    // enable dev mode if env is develop or if ?dev=true is provided in the url
    // if(process.env.NODE_ENV === 'development' || query.dev === 'true'){
    if (process.env.NODE_ENV === 'development') {
      setDev(true);
      //a11y(React, { ReactDOM: ReactDOM, includeSrcNode: true });
    } else if (query.dev === 'false') {
      setDev(false);
    }
  }

  render() {
    const {
      spinner,
      children,
      pageErrors,
      dev
    } = this.props;

    const query = queryString.parse(window.location.search);
    const showLabels = (query.labels === 'true');
    const containerClasses = classNames({
      'mp-main': true,
      'mp-main--omni': true,
      'show-labels': showLabels,
      'dev': dev
    });

    return (
      <Spinner
        show={spinner.show}
        priority={10}
        isGlobal={true}
        message={spinner.message}
        backgroundStyle={{position: 'fixed'}}
        hideContentOnLoad={spinner.hideContent}>
        <Nav />
        {
          !_.isEmpty(pageErrors) &&
          <div className="x-error-panel-container container">
            <ErrorPanel errors={pageErrors} />
          </div>
        }
        <div className={containerClasses} role="main">
          {children}
        </div>
        <Footer />
      </Spinner>
    );
  }
}

AppContainer.childContextTypes = {
  logUserClick: PropTypes.func
};

AppContainer.propTypes = {
  children: PropTypes.node,
  spinner: PropTypes.object.isRequired,
  pageErrors: PropTypes.array,
  setDev: PropTypes.func.isRequired,
  dev: PropTypes.bool.isRequired,
  logUserClick: PropTypes.func
};

function mapStateToProps(state) {
  return {
    spinner: state.common.spinner,
    pageErrors: state.common.pageErrors,
    dev: state.common.dev
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setDev: bindActionCreators(dispatchSetDev, dispatch),
    logUserClick: bindActionCreators(logUserClick, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppContainer);



/** WEBPACK FOOTER **
 ** ./client/containers/AppContainer.jsx
 **/